interface Config {
  mainURL: string
  clientId: string | number
  clientSecret: string,
  termCondition: {vi: string, en: string; kr: string},
  privatePolicy: {vi: string, en: string; kr: string},
  googleCaptchaClientKey: string,
}

const config: Config = {
  mainURL: 'https://api.swift247.vn',
  clientId: 4,
  clientSecret: 'zO9htNVofNmHUdCRme4b6910AUOLdDVSykEYKbNz',
  termCondition: {
    vi: 'https://swift247.vn/dieu-khoan-su-dung',
    en: 'https://swift247.vn/en/terms-and-conditions',
    kr: 'https://swift247.vn/en/terms-and-conditions',
  },
  privatePolicy: {
    vi: 'https://swift247.vn/chinh-sach-bao-mat-s247',
    en: 'https://kr.swift247.vn/en/privacy-policy.html',
    kr: 'https://kr.swift247.vn/kr/privacy-policy.html',
  },
  googleCaptchaClientKey: '6LfLMCInAAAAAHNjhEsXT6JpWI2mUAz8UTKxuUzj'
}

export default config;
